import { Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CustomModalService } from '@piqet-angular/shared';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'piqet-angular-custom-category',
  templateUrl: './custom-category.component.html',
  styleUrls: ['./custom-category.component.css'],
})
export class CustomCategoryComponent {
  modalLabel: any;

  submitted = false;
  @Output() saveCustomCategoryEvent = new EventEmitter<any>();
  customCategoryData: any;
  customCategoryEditForm!: FormGroup;
  selectedCategories: any;
  categoryItemList: any;
  categoryID: any;

  constructor(
    private formBuilder: FormBuilder,
    private modal: CustomModalService,
    private cookieService: CookieService
  ) {
    this.modalLabel = this.modal?.modalService?.config?.initialState?.['headerName'];
    this.customCategoryData =
      this.modal?.modalService?.config?.initialState?.['customCategoryData'];
    this.categoryItemList = this.customCategoryData.indicatorItems;
  }

  ngOnInit(): void {
    this.customCategoryEditForm = this.formBuilder.group({
      indicators: [this.customCategoryData.indicatorIds || null, [Validators.required]],
    });
  }

  onClose() {
    this.modal.close();
  }

  onSave() {
    this.submitted = true;
    this.categoryID = this.selectedCategories.map((data: any) => {
      return data.id;
    });
    const data = {
      organizationId: Number(this.cookieService.get('organizationId')),
      indicatorIds: this.categoryID,
    };
    this.saveCustomCategoryEvent.emit(data);
  }

  selectProduct(event: any) {
    this.selectedCategories = event;
  }
}
